// extracted by mini-css-extract-plugin
module.exports = {"toggler":"styles_toggler__3FDev"};